import { getInitial } from "../../../../services/utils";
import { ImageView } from "../../../../components/Image";

export const UserProfileView = ({ user }: { user: any }) => {
  return (
    <div className="flex justify-between items-start">
      <div className="flex items-start gap-4">
        <div className="w-[70px] h-[70px] rounded-full">
          {user?.profileImg ? (
            <ImageView
              className="w-[70px] h-[70px] rounded-full object-cover"
              src={user?.profileImg}
              alt="user"
            />
          ) : (
            <div className="bg-primary w-[70px] h-[70px] rounded-full text-text-secondary text-lg flex justify-center items-center font-semibold">
              {getInitial(user?.firstName, user?.lastName)}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-4">
            <span className="text-[22px] text-text2">
              {user?.firstName} {user?.lastName}
            </span>
            <div className="bg-[#D0EADC] rounded text-[11px] w-24 h-6 flex items-center justify-center">
              Active Today
            </div>
          </div>
          <div className="text-sm text-text2">Level 2, Account Specialist</div>
          <div className="flex items-center gap-4 text-sm text-text2">
            <span>{user?.email}</span>
            <span>{user?.phone}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
